import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AbstractControl, FormGroup, ReactiveFormsModule } from '@angular/forms';

import { ButtonModule } from 'primeng/button';
import { TextControlComponent } from '../../form-control-components/text-control/text-control.component';
import { NumberControlComponent } from '../../form-control-components/number-control/number-control.component';
import { DropdownControlComponent } from '../../form-control-components/dropdown-control/dropdown-control.component';
import { CalendarControlComponent } from '../../form-control-components/calendar-control/calendar-control.component';
import { CheckboxControlComponent } from '../../form-control-components/checkbox-control/checkbox-control.component';
import { FileUploadControlComponent } from '../../form-control-components/file-upload-control/file-upload-control.component';
import { InputMaskControlComponent } from '../../form-control-components/input-mask-control/input-mask-control.component';
import { BaseControl, ConfigurationType, ControlType, FormPage, TypeChecker } from '../../../shared';
import { FormCreatorService, IConfigurationSection } from '../../../services';
import { TranslateModule } from '@ngx-translate/core';
import { CustomTagComponent } from '../../custom-work/other/custom-tag/custom-tag.component';
import { LabelControlComponent } from '../../form-control-components/label-control/label-control.component';
import { InputTextareaControlComponent } from '../../form-control-components/input-textarea-control/input-textarea-control.component';
import { TooltipModule } from 'primeng/tooltip';
import { SubFormulariosContainerComponent } from '../../form-control-components/sub-formulario-control/sub-formularios-container.component';
import { DragDropModule } from 'primeng/dragdrop';

@Component({
  selector: 'app-form-section-control',
  standalone: true,
  imports: [
    CommonModule, ReactiveFormsModule, TooltipModule,
    TextControlComponent, NumberControlComponent, DropdownControlComponent, CalendarControlComponent, CheckboxControlComponent, FileUploadControlComponent,
    InputMaskControlComponent, ButtonModule, TranslateModule, CustomTagComponent, LabelControlComponent, InputTextareaControlComponent,
    SubFormulariosContainerComponent, DragDropModule
],
  styleUrl: './form-section-control.component.scss',
  templateUrl: "./form-section-control.component.html"
})
export class FormSectionControlComponent {
  @Input() page !: FormPage;
  @Input() control !: BaseControl<any>;
  @Input() pageFormGroup !: FormGroup;
  @Input() isDesigner !: boolean;

  configurationType = ConfigurationType;
  controlType = ControlType;
  typeChecker = TypeChecker;

  constructor(public fc: FormCreatorService) {
  }

  getControlFormGroup(controlName: string): AbstractControl {
    const control = this.pageFormGroup?.get(controlName);
    if (control instanceof AbstractControl) {
      return control;
    }
    throw new Error('FormControl not found');
  }

  onShowConfiguration(event: Event, type: ConfigurationType, page?: FormPage, control?: BaseControl<any>) {
    event.stopPropagation();
    if (!this.isDesigner) return
    const configuration = { show: true, type: type, page: page, control: control } as IConfigurationSection;
    this.fc.emitShowConfigurationEvent(configuration, event.currentTarget as HTMLElement);
  }

  handleKey(event: KeyboardEvent, type: ConfigurationType, page?: FormPage, control?: BaseControl<any>): void {
    event.stopPropagation();
    if (!this.isDesigner) return
    if (event.key === 'Enter' || event.key === ' ') {
      const configuration = { show: true, type: type, page: page, control: control } as IConfigurationSection;
      this.fc.emitShowConfigurationEvent(configuration, event.currentTarget as HTMLElement);
    }
  }

  stopEvent(event: Event): void {
    event.stopPropagation();
  }

  //#region Drag and Drop
  onControlDrop($event: DragEvent, page: FormPage, control: BaseControl<any>) {
    if (!this.fc.dragStartControl || !this.fc.dragStartPage) return;
    this.fc.moveControl(
      this.fc.dragStartControl.name,
      control.name,
      $event.offsetX < ($event.target as HTMLElement).clientWidth / 2 ? 'left' : 'right'
    );
    this.fc.clearDragData();
  }

  onControlDragEnd($event: DragEvent, page: FormPage, control: BaseControl<any>) {
    this.fc.clearDragData();
  }

  onControlDragStart($event: DragEvent, page: FormPage, control: BaseControl<any>) {
    this.fc.dragStartControl = control;
    this.fc.dragStartPage = page;
  }
  //#endregion Drag and Drop
}
